import React, { useContext, useEffect, useRef, useState } from 'react'
import Popup from '../../../Components/Popup';
import { CheckValidation } from '../../../Components/Validations';
import { CustomParseSafeHtml, encryptText, getTodayDate, HideLoder, LogInSchoolID, LogInUserID, ShowLoder, ymdToDate, YYYYMMDD } from '../../../JS/Common';

import { ApiGetCall, ApiPostCall } from '../../../JS/Connector';
import AlertsComp from '../../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { UserContext } from '../../../App';
import { secureEncrypt } from '../../../Utils/SecureEncrypt';
import CustomReactDatePicker from '../../../Components/CustomReactDatePicker';
import useConfig from '../../../Hooks/useConfig';

export default function ImportIQDevices() {
    const { secondary_text, enterprise_name } = useConfig();
    const [isDetailPopup, setisDetailPopup] = useState(false);
    const [isRemoveIIQPopup, setIsRemoveIIQPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [showButtons, setshowButtons] = useState(true);
    const [NewAlerts, setNewAlerts] = useState("");
    const [returnStatus, setreturnStatus] = useState("");
    const initialPopupData = {
        api: "",
        token: "",
        siteid: "",
        Keyword: '',
        UserId: '',
        productId: '',
        syncTwoWay: 0,
        expireAt: '',
        newDeviceCreation: 0,
    }
    const [popupData, setPopupData] = useState(initialPopupData);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState(new Set([1]));
    const [ticketImportData, setticketImportData] = useState({
        accountname: '',
        notes_part_flag: 2
    })
    const [showPopover, setShowPopover] = useState(false);
    const { UserData, setUserData } = useContext(UserContext);
    const { emailid: loggedinemailid } = UserData;
    const exampleRef = useRef(null);
    useEffect(() => {
        if (UserData.iiqSetUp == 1) {
            setreturnStatus('success')
        } else {
            setreturnStatus('')
        }
    }, [UserData])
    useEffect(() => {
        if (popupData.syncTwoWay == 1 && exampleRef.current) {
            exampleRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [popupData.syncTwoWay]);

    async function AddIQData() {
        var isFormValid = CheckValidation({ formID: 'IncidentData' });
        if (!isFormValid) return;
        var today = getTodayDate();
        setLoading(true);
        try {
            // For JWT token, use hybrid encryption
            // const encryptedToken = await secureEncrypt.encryptJWTToken(popupData?.token?.trim() || '');
            //  For other fields, use simple RSA (they're smaller)
            // const encryptedApi = await secureEncrypt.encryptField(popupData?.api?.trim() || '');
            // const encryptedSiteId = await secureEncrypt.encryptField(popupData?.siteid?.trim() || '');
            // const encryptedAssignWord = await secureEncrypt.encryptField(popupData?.Keyword?.trim() || '');
            // const encryptedUserId = await secureEncrypt.encryptField(popupData?.UserId?.trim() || '');
            // const encryptedProductId = await secureEncrypt.encryptField(popupData?.productId?.trim() || '');
            var raw = JSON.stringify({
                loginEmail: loggedinemailid,
                schoolId: LogInSchoolID,
                apiBearer: popupData?.token?.trim() || '', // Hybrid encrypted
                api: popupData?.api?.trim() || '', // Simple RSA
                expiresAt: popupData.expireAt,
                userNumber: popupData?.UserId ? popupData?.UserId?.trim() || '' : null, // Simple RSA
                syncTwoWay: popupData.syncTwoWay,
                newDeviceCreation: popupData.newDeviceCreation
            });
            const result = await ApiPostCall("/iiq/incident-credentials", raw);
            if (!result || result === "") {
                alert("Something went wrong");
                return;
            }
            const responseRs = JSON.parse(result)
            if (responseRs.status === "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={"Your IncidentIQ account has been successfully connected"} />);
                setTimeout(() => {
                    setisDetailPopup(false);
                    setLoading(false);
                    setreturnStatus('success');
                    setUserData({ ...UserData, iiqSetUp: 1, iiqTag: popupData.Keyword })
                    setshowButtons(false);
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);
            } else {
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.msg} />);
                setLoading(false);
            }
        } catch (error) {
            setNewAlerts(<AlertsComp show={true} variant="danger" msg={'Something went wrong'} />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
            setLoading(false);
        }
    }
    const handleCheckboxChange = (id) => {
        setSelectedCheckboxes((prev) => {
            const updated = new Set(prev);
            if (updated.has(id)) {
                updated.delete(id);
            } else {
                updated.add(id);
            }
            updated.add(1);
            return updated;
        });
    };
    const handleToggle = (nextShow) => {
        setShowPopover(nextShow);
    };
    const popover = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Body>
                <div>
                    This is the account that tickets will be assigned to for them to show up in {secondary_text}, usually labeled {enterprise_name} or something similar.
                </div>
            </Popover.Body>
        </Popover>
    );

    const stepData = [
        {
            stepNo: "01",
            stepTitle: "Log In and Access Developer Tools",
            stepDesc: null,
            stepPoints: [
                "Login to IncidentIQ as an Administrator.",
                "On the left menu, open the Admin section.",
                "Click Developer Tools."
            ],
            stepImg: "/images/StepImg01.png"
        },
        {
            stepNo: "02",
            stepTitle: "Create a New Developer Token",
            stepPoints: [
                "Under “Create New Token”, select an IIQ Administrator account to make the token with.",
                `Select and copy the generated token to paste into the “Token” field given below in ${secondary_text}. This will be the <b>only time you can copy</b> this token without deleting it and restarting.`
            ],
            stepImg: "/images/StepImg02.png"
        },
        {
            stepNo: "03",
            stepTitle: `Copy the following information to paste into ${secondary_text}`,
            stepPoints: [
                `From the Existing Token section, on the token you just made, copy the “Expire At Date” into ${secondary_text}.`,
                `Scroll down to the Site Info section, and copy the “API URL” into ${secondary_text}.`,
                {
                    text: "(Optional) If you are looking to have information put back into IncidentIQ, you will need to provide a iiQ User ID below in the “Comment User ID” field.",
                    subPoints: [
                        "This should generally be the same account as the one you used for the API Token.",
                        "If you need a different user’s ID, go into User Explorer, find the user you want and when on their profile, the user ID will be at the end of the URL in this format (incidentiq.com/agent/users/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx or &flyout-id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)"
                    ]
                }
            ],
            stepImg: "/images/StepImg03.png"
        },
        {
            stepNo: "04",
            stepTitle: "Complete Connection",
            stepDesc: null,
            stepPoints: [
                "Enter all collected pieces of information into the fields below to finalize the integration.",
                "<b>Note: Your tickets will be synced automatically every night.</b>"
            ],
            stepImg: null
        },
    ]

    const ModalStepsLayout = ({ stepNo, stepTitle, stepDesc, stepPoints, stepImg }) => {
        return (
            <div className={`row ${stepNo == "04" || stepNo == '05' ? '' : 'pt-3'} mb-2`}>
                <div className={`${stepNo == "04" || stepNo == '05' ? 'col-md-12' : 'col-md-6'} ${stepNo == "02" || stepNo == '03' ? 'pt-3' : ''}`}>
                    <div className='d-flex align-items-end h-auto w-100 mb-2' style={{ color: 'var(--primary-color)' }}>
                        <label>STEP</label> <h2 className=' fw-bold m-0 ps-2'>{stepNo}</h2>
                    </div>
                    <div className='w-100'>
                        {stepTitle && <label className='fw-semibold pb-2'> {stepTitle} </label>}
                        {stepDesc && <label className='pb-2'> {stepDesc} </label>}
                        <ul className='mb-0'>
                            {stepPoints && stepPoints.map((point, index) => (
                                <li key={index} className='pb-1'>
                                    {typeof point === "string" ? (
                                        CustomParseSafeHtml(point)
                                    ) : (
                                        <>
                                            {CustomParseSafeHtml(point.text)}
                                            {point.subPoints && (
                                                <ul className='mt-1'>
                                                    {point.subPoints.map((sub, subIndex) => (
                                                        <li key={subIndex} className='pb-1'>
                                                            {CustomParseSafeHtml(sub)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {stepImg &&
                    <div className={`col-md-6 `}>
                        <img src={stepImg} alt={stepNo} className='img-fluid' />
                    </div>
                }
                {stepNo != "04" &&
                    <div className='d-flex justify-content-center w-100 mt-2'>
                        <img src='/images/CenteredLine.svg' alt='CenteredLine' className='w-75' />
                    </div>
                }
            </div>
        )
    }

    const modalBody = (
        <div id="IncidentData" className="parent">
            {showButtons == true && (
                <>
                    <label className='py-1'>Follow these steps to retrieve your API credentials and connect your IncidentIQ tickets to {secondary_text}.</label>
                    <div className='font-13 mb-3'>
                        {stepData.map((steps) => (
                            <ModalStepsLayout
                                stepNo={steps.stepNo}
                                stepTitle={steps.stepTitle}
                                stepDesc={steps.stepDesc}
                                stepPoints={steps.stepPoints}
                                stepImg={steps.stepImg}
                            />
                        ))}
                    </div>

                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='FormLabel'>Expire At<label className='redText'>*</label></div>
                            <CustomReactDatePicker
                                isRequired="true"

                                selectedDate={popupData.expireAt ? ymdToDate(popupData.expireAt) : null}

                                onChangeHandler={(date) => setPopupData({ ...popupData, expireAt: date ? YYYYMMDD(date) : "" })}
                                placeholderText="MM-DD-YYYY"
                            />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                        <div className='col-md-4'>
                            <div className='FormLabel'>Enter Token<label className='redText'>*</label></div>
                            <input type='text' className="form-control" autoComplete='off' name='token' required
                                value={popupData.token}
                                onChange={(e) => setPopupData({ ...popupData, token: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                        <div className='col-md-4'>
                            <div className='FormLabel'>Enter API URL<label className='redText'>*</label></div>
                            <input type='text' className="form-control" autoComplete='off' name='api' required
                                value={popupData.api}
                                onChange={(e) => setPopupData({ ...popupData, api: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                        <div className='col-md-12 d-flex mt-3'>
                            <label className="FormLabel">
                                Would you like to sync information back to iiQ?
                                <span className="tooltip-wrapper">
                                    <img
                                        src="/images/InfoIcon.svg"
                                        className="info-icon"
                                        height="14"
                                        alt="info"
                                    />
                                    <span className="tooltip-text">
                                        When enabled, {secondary_text} will sync finalized repair information back to iiQ
                                        in a predefined note format.
                                    </span>
                                </span>
                            </label>

                            <div className='d-flex ps-4'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name='syncTwoWay' checked={popupData.syncTwoWay == 1} onChange={(e) => setPopupData({ ...popupData, syncTwoWay: 1 })} />
                                    <label className="form-check-label"> Yes</label>
                                </div>
                                <div className="form-check ms-3">
                                    <input className="form-check-input" type="radio" name='syncTwoWay' checked={popupData.syncTwoWay == 0} onChange={(e) => setPopupData({ ...popupData, syncTwoWay: 0, UserId: '' })} />
                                    <label className="form-check-label"> No </label>
                                </div>
                            </div>

                        </div>
                        <div className='px-3'>
                            {popupData.syncTwoWay == 1 && (
                                <>
                                    <label className='mt-3 fw-600'>Please provide User ID of a User whose name should be used for posting a comment.</label>
                                    <div className='col-md-6'>
                                        <div className='FormLabel'>Comment User ID</div>
                                        <input type='text' className="form-control" autoComplete='off' name='UserId'
                                            value={popupData.UserId}
                                            onChange={(e) => setPopupData({ ...popupData, UserId: e.target.value })} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                    <div className="mt-3 px-3 pt-2 border rounded bg-light">
                                        <div ref={exampleRef} className="fw-600 mb-2">
                                            Example note sent to Incident IQ with each synced ticket when batch is finalized from {enterprise_name} team
                                        </div>
                                        <pre className='small'>
                                            <div>{enterprise_name} Repair Notes : (Repair Notes on Ticket)</div>
                                            <div>{enterprise_name} Replaced Parts : (Replaced Part 1, $50), (Replaced Part 2, $70) - (Total: $120)</div>
                                        </pre>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className='col-md-12 d-flex mt-3'>
                            <label className="FormLabel">
                                Create New Devices in Rocket?
                                <span className="tooltip-wrapper">
                                    <img
                                        src="/images/InfoIcon.svg"
                                        className="info-icon"
                                        height="14"
                                        alt="info"
                                    />
                                    <span className="tooltip-text">
                                        If this option is set to No, the IncidentIQ integration will not make any new devices inside of {secondary_text}, and will only make tickets using currently existing devices.
                                    </span>
                                </span>
                            </label>

                            <div className='d-flex ps-4'>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name='newDeviceCreation' checked={popupData.newDeviceCreation == 1} onChange={(e) => setPopupData({ ...popupData, newDeviceCreation: 1 })} />
                                    <label className="form-check-label"> Yes</label>
                                </div>
                                <div className="form-check ms-3">
                                    <input className="form-check-input" type="radio" name='newDeviceCreation' checked={popupData.newDeviceCreation == 0} onChange={(e) => setPopupData({ ...popupData, newDeviceCreation: 0 })} />
                                    <label className="form-check-label"> No </label>
                                </div>
                            </div>

                        </div>
                    </div>
                </>
            )}

            {!showButtons &&
                <div className='col-12 text-center'>
                    {returnStatus == "success" ?
                        <div className='row'>
                            <label className='mb-3 schoolColorStatus'>
                                Your IncidentIQ account has been successfully connected. Would you like to sync your existing data records with {secondary_text} now?
                            </label>
                        </div>
                        : returnStatus == "error" ?
                            <label className='mb-3 redText'>
                                Sorry, we could not connect your incidentIQ account with {secondary_text}. Please make sure you have entered correct credentials, click here to try again. If you continue facing this issue, please contact {secondary_text} administrator from here.
                            </label>
                            :
                            <></>
                    }

                </div>

            }
        </div>
    );
    const modalBodyForRemoveIIQ = (
        <div className="">
            <label className='py-1'>Your iiQ Tickets will not longer be synced with {secondary_text} account</label>
        </div>
    );

    async function ImportTicketCall() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            loginUserId: LogInUserID,
        });
        await ApiPostCall("/tickets/iiq/import ", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result)
                setLoading(false);
                if (responseRs?.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Tickets synced successfully"} />);
                    setTimeout(() => {
                        setreturnStatus('success');
                        setshowButtons(false);
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    async function RemoveIIQAccount() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
        });
        await ApiPostCall("/iiq/accounts/remove", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result)
                setLoading(false);
                if (responseRs.status === "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Your account has been removed successfully"} />);
                    setTimeout(() => {
                        setreturnStatus('');
                        setshowButtons(true)
                        setIsRemoveIIQPopup(false)
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs?.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }

    const modalFooterForRemoveIIQ = (
        <div className='row'>
            <div className=' d-flex px-0 text-end align-items-center'>
                <label className="ms-2 cursor-pointer" onClick={(e) => { setIsRemoveIIQPopup(false) }}><u>Cancel</u></label>
                <button className={`SaveBtn ms-2`} onClick={RemoveIIQAccount}>Yes, Disconnect</button>
            </div>
        </div>
    )
    async function saveAssets() {
        setLoading(true);
        var raw = JSON.stringify({
            schID: LogInSchoolID,
            selectedIds: Array.from(selectedCheckboxes),
            accountName: selectedCheckboxes.has(2) ? ticketImportData.accountname : null,
            notesPartFlag: selectedCheckboxes.has(2) ? ticketImportData.notes_part_flag : null
        });
        await ApiPostCall("/AddIncidentImportPreferences", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Assets Added Successfully."} />);
                    setisDetailPopup(false);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        navigate('/manage-device');
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                }
            }
        });
    }

    const modalfooter = (
        <div className='row'>
            <div className='col-10 ps-0 font-13'>
                <div className='text-justify schoolColorStatus' style={{ letterSpacing: "normal" }}>
                    <label><label className='fw-semibold '>Notes : </label> Please note that your IncidentIQ API URL and Token are encrypted within {secondary_text}. Your data is safeguarded within your account by our security protocols. </label>
                </div>
            </div>
            <div className='col-2 px-0 text-end'>
                <label className="ms-2 cursor-pointer" onClick={(e) => {
                    setPopupData(initialPopupData);
                    setisDetailPopup(false);
                    setshowButtons(true)
                }}><u>Cancel</u></label>
                <button className={`SaveBtn ms-2`} onClick={AddIQData}>Save</button>
            </div>
        </div>

    )
    const modalfooterimport = (
        <>
            {returnStatus == "success" ?
                <>
                </>
                :
                <>
                    <label className="ms-2 cursor-pointer" onClick={(e) => {
                        setPopupData(initialPopupData);
                        setisDetailPopup(false);
                        setshowButtons(true);
                    }}><u>Cancel</u></label>
                </>
            }
        </>

    )
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='d-flex align-items-center p-1 justify-content-between'>
                <span className='GridTitle pb-2'>Import Your Incident IQ Devices</span>
                <div className=""><img src="/images/Incident_iq.svg" className="img-fluid pe-2" /></div>
            </div>
            <hr className='my-0' />
            {returnStatus ?
                <>
                    <div className="mt-3 mb-2">
                        <p className="text-justify" style={{ fontSize: "13px" }}>
                            Your IncidentIQ account is connected to {secondary_text}. Would you like to sync your records now?
                        </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <button className="SaveBtn" onClick={ImportTicketCall}>
                            Sync Your IncidentIQ Tickets
                        </button>
                        <button type="button" className="Remove-btn ms-3" onClick={(e) => { setIsRemoveIIQPopup(true) }} style={{ borderRadius: '16px' }}>
                            Disconnect iiQ Account
                        </button>
                    </div>
                </>
                :
                <>
                    <div className="mt-3 mb-2">
                        <p className="text-justify" style={{ fontSize: "13px" }}>
                            Connect your incidentIQ account with {secondary_text} for seamless sync between two systems. Click below to get started!
                        </p>
                    </div>
                    <div className='col-md-12 mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <button className="MicrosoftGoogleBtn" onClick={(e) => {
                                    setisDetailPopup(true);
                                    setPopupData(initialPopupData);
                                }}>
                                    <div className="">
                                        <img src="/images/Incident_iq.svg" className="img-fluid pe-3" />
                                        Integrate incidentIQ Account
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }

            <Popup isshow={isDetailPopup} size={"xl"} title={`Connect incidentIQ to ${secondary_text}`}
                closePopup={(e) => {
                    setPopupData(initialPopupData);
                    setisDetailPopup(false);
                    setshowButtons(true)
                }}
                modalBody={modalBody}
                modalfooter={showButtons ? modalfooter : modalfooterimport}
                isCentered={true}
                isScrollable={true}
            />
            <Popup isshow={isRemoveIIQPopup} size={"md"} title={'Disconnect iiQ Account'}
                closePopup={(e) => { setIsRemoveIIQPopup(false); }}
                modalBody={modalBodyForRemoveIIQ}
                modalfooter={modalFooterForRemoveIIQ}
                isCentered={true}
                isScrollable={true}
            />
        </div>
    )
}
